import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Mail, Smartphone } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="bg-wellness-green py-20 px-6" data-id="element-51">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-2xl mx-auto text-center" data-id="element-52">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-53">
          Empieza tu reset hoy
        </h2>
        <p className="text-lg text-white/90 mb-8 max-w-lg mx-auto" data-id="element-54">
          Recibes la guía en tu email inmediatamente después del pago. PDF
          descargable, compatible con cualquier dispositivo.
        </p>

        <a href="https://cuerpoencalma.it.com/cart/49295445262573:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('final_cta')} className="inline-block bg-wellness-gold text-white px-10 py-4 rounded-full font-bold text-lg tracking-wide shadow-xl hover:bg-yellow-500 transition-all hover:scale-105 active:scale-95 mb-8" data-id="element-55">
          Quiero mi guía — US$ 6.36
        </a>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-white/80" data-id="element-56">
          <div className="flex items-center gap-2" data-id="element-57">
            <Lock className="w-4 h-4" data-id="element-58" />
            <span data-id="element-59">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-60">
            <Mail className="w-4 h-4" data-id="element-61" />
            <span data-id="element-62">Entrega inmediata por email</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-63">
            <Smartphone className="w-4 h-4" data-id="element-64" />
            <span data-id="element-65">Compatible con cualquier dispositivo</span>
          </div>
        </div>
      </motion.div>
    </section>;
}